import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromAccountAllocations from './store/account-allocation.reducer';
import { EffectsModule } from '@ngrx/effects';
import { AccountAllocationsEffects } from './store/account-allocation.effects';
import { AccountAllocationsContainerComponent } from './account-allocations-container';
import { UIRouterModule } from '@uirouter/angular';
import { AccountAllocationRoute } from './account-allocation.route';
import { AccountAllocationsComponent } from './account-allocations/account-allocations.component';
import { SharedModule } from '../../shared/shared.module';
import { PostingAccountComponent } from './posting-account/posting-account.component';
import { PostingAccountContainerComponent } from './posting-account-container/posting-account-container.component';
import { CostAllocationContainerComponent } from './cost-allocation-container/cost-allocation-container.component';
import { CostAllocationComponent } from './cost-allocation/cost-allocation.component';
import { FacilityContainerComponent } from './facility-container/facility-container.component';
import { FacilityComponent } from './facility/facility.component';
import * as fromFacilityAllocation from './store/facility-allocation.reducer';
import { FacilityAllocationEffects } from './store/facility-allocation.effects';
import * as fromAccountPostingType from './store/account-posting-type.reducer';
import { AccountPostingTypeEffects } from './store/account-posting-type.effects';
import { AccountsReceivableContractContainerComponent } from './accounts-receivable-contract-container/accounts-receivable-contract-container.component';
import { AccountsReceivableContractComponent } from './accounts-receivable-contract/accounts-receivable-contract.component';

@NgModule({
    declarations: [
        AccountAllocationsContainerComponent,
        AccountAllocationsComponent,
        PostingAccountComponent,
        PostingAccountContainerComponent,
        CostAllocationContainerComponent,
        CostAllocationComponent,
        FacilityContainerComponent,
        FacilityComponent,
        AccountsReceivableContractContainerComponent,
        AccountsReceivableContractComponent
    ],
    imports: [
        CommonModule,
        UIRouterModule,
        SharedModule,
        UIRouterModule.forChild({
            states: [AccountAllocationRoute]
        }),
        StoreModule.forFeature(
            fromAccountAllocations.accountAllocationsFeatureKey,
            fromAccountAllocations.reducer
        ),
        StoreModule.forFeature(
            fromFacilityAllocation.facilityAllocationsFeatureKey,
            fromFacilityAllocation.reducer
        ),
        StoreModule.forFeature(
            fromAccountPostingType.accountPostingTypesFeatureKey,
            fromAccountPostingType.reducer
        ),
        EffectsModule.forFeature([
            AccountAllocationsEffects,
            FacilityAllocationEffects,
            AccountPostingTypeEffects
        ])
    ],
    exports: [AccountAllocationsContainerComponent, AccountAllocationsComponent]
})
export class AccountAllocationsModule {}
